<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="error-template">
        <h1>
          Oops!</h1>
        <h2>
          404 Not Found</h2>
        <div class="error-details">
          La página solicitada no ha sido encontrada
        </div>
        <div class="error-actions">
          <button type="button" class="btn btn-primary" [routerLink]="'/'">Volver a la página de inicio</button>
          <button type="button" class="btn btn-primary" (click)="goBack()">Volver atrás</button>
        </div>
      </div>
    </div>
  </div>
</div>
